module.exports = __webpack_public_path__ + "media/images/top/img_pickup_bigiya-93575ac73323ae8c3b98df17e20f114e.webp";